import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { companyInfo } from "@/data/mock";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const offset = 90;
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top, behavior: "smooth" });
    setIsMobileMenuOpen(false);
  };

  const openWA = () => {
    const text = `Halo, saya ingin informasi produk ${companyInfo.brand} (bumbushakti). Boleh minta katalog & pricelist?`;
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${encodeURIComponent(text)}`, "_blank");
  };

  const menuItems = [
    { id: "hero", label: "Beranda" },
    { id: "about", label: "Tentang Kami" },
    { id: "fasilitas", label: "Fasilitas" },
    { id: "produk", label: "Produk" },
    // { id: "kemasan", label: "Kemasan" },
    { id: "sertifikasi", label: "Legalitas" },
    { id: "mengapa", label: "FAQ" },
    { id: "kontak", label: "Kontak" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg" : "bg-white/95 backdrop-blur-sm"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo + Company */}
          <button
            onClick={() => scrollToSection("hero")}
            className="flex items-center space-x-3 text-left"
            aria-label="Kembali ke Beranda"
          >
            <div className="w-12 h-12 rounded-lg overflow-hidden shadow-lg border-[#a00e21] bg-white flex items-center justify-center">
              <img
                src={companyInfo.logo}
                alt="Logo SHAKTI"
                className="w-full h-full object-contain"
              />
            </div>

            <div>
              <h1 className="font-black text-lg text-gray-900 leading-tight">
                {companyInfo.brand}
              </h1>
              <p className="text-xs text-[#a00e21] font-semibold leading-tight">
                {companyInfo.name}
              </p>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-7">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-[#a00e21] font-semibold transition-colors duration-200 relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#a00e21] group-hover:w-full transition-all duration-300" />
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={openWA}
              className="bg-[#a00e21] hover:bg-[#8a0c1c] text-white font-semibold px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center space-x-2"
            >
              <Phone size={18} />
              <span>Hubungi (WA)</span>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen((v) => !v)}
            className="md:hidden text-gray-700 hover:text-[#a00e21] transition-colors"
            aria-label="Buka menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-3">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-[#a00e21] font-semibold transition-colors duration-200 text-left py-2"
              >
                {item.label}
              </button>
            ))}

            <div className="text-sm text-gray-600 pt-2">
              <div className="font-semibold">Telp: {companyInfo.phone}</div>
              <div className="font-semibold">Email: {companyInfo.emailPrimary}</div>
            </div>

            <Button
              onClick={openWA}
              className="bg-[#a00e21] hover:bg-[#8a0c1c] text-white font-semibold w-full py-3 rounded-lg shadow-lg flex items-center justify-center space-x-2"
            >
              <Phone size={18} />
              <span>Chat WhatsApp</span>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
